import {
  FGButton,
  FGCheckbox,
  FGTypography

} from '@fg/design-system';
import { useEffect, useState } from 'react';
import { auto } from '@popperjs/core';
import { HeaderFooter } from './HeaderFooter';
import { verifyEmail } from '../services/Login';


type Props = {
  customProps: {
    appCode: string;
    logoType: string;
    callback: string;
    stateOauth: string;
    csrfToken: string;
  };
};
export const AccountConfirmation = ({ customProps }: Props) => {
  const [email, setEmail] = useState('');
  const [registrationConfirmation, setRegistrationConfirmation] = useState(true);
  const [isTermsOfUse, setIsTermsOfUse] = useState(false);
  const [isEventsPolicy, setisEventsPolicy] = useState(false);
  const [isCookiePolicy, setisCookiePolicy] = useState(false);
  const { appCode, logoType, stateOauth, callback, csrfToken } = customProps;
  const linkStyle = { textDecoration: 'none' };
  const [errorMessage, setErrorMessage] = useState('');
  const copyrightText = "Copyright © 2025 Fitch Ratings, Inc., Fitch Solutions, Inc., and their subsidiaries.";

  const handeTermsOfUseChange = () => {
    setIsTermsOfUse(!isTermsOfUse);
  };
  const handleEventsPolicyChange = () => {
    setisEventsPolicy(!isEventsPolicy);
  };
  const handleCookiePolicyChange = () => {
    setisCookiePolicy(!isCookiePolicy);
  };

  function TermsOfUse() {
    return (
      <label className="fg-checkbox__label">
        I agree to the
        {' '}
        <a href="https://www.fitch.group/terms-of-use" target="_blank" rel="noopener noreferrer" style={linkStyle}>Terms Of Use</a>
        .
      </label>
    );
  }
  function EventsPolicy() {
    return (
      <label className="fg-checkbox__label">
        I agree to the terms and conditions in the
        {' '}
        <a href="https://www.fitch.group/event-policy" target="_blank" rel="noopener noreferrer" style={linkStyle}>Events Policy</a>
        .
      </label>
    );
  }
  function CookiePolicy() {
    return (
      <label className="fg-checkbox__label">
        I consent to the use of cookies by creating my account as described in the 
        {' '}
        <a href="https://www.fitch.group/cookie-policy" target="_blank" rel="noopener noreferrer" style={linkStyle}>Cookie Policy</a>
        .
      </label>
    );
  }
  useEffect(() => {
    const storedUserEmail = sessionStorage.getItem('userEmail');
    setEmail(storedUserEmail);
    setRegistrationConfirmation(true);
  }, []);

  const handleClick = () => {
    const data = {
      email: email,
      appCode: appCode,
      state: stateOauth,
      callback: callback,
      registrationConfirmation: registrationConfirmation
    };
    verifyEmail(data, csrfToken)
      .then((response) => {
        if (response.redirectUrl) {
          sessionStorage.setItem('userEmail', response.userEmail);
          window.location.href = response.redirectUrl;
        }
        if (response.error || response.message) {
          setErrorMessage(response.message);
        }
      })
      .catch((error: any) => {
        setErrorMessage(error);
      });
  };
  return (
    <>
      <HeaderFooter appCode={appCode} logoType={logoType} copyrightText={copyrightText}>
        <br></br>
        <br></br>
        <FGTypography color="strong" tag="h3" style="headline3" alignment="center">
          Create your free account
        </FGTypography>
        <br></br>
        <FGTypography color="strong" tag="p" style="body1" alignment="left" className="fg-checkbox__label" cssStyle={{ maxWidth: '570px', margin: 'auto' }} >
          By creating an account on the Fitch Ratings website, you consent to the collection and use of your personal data for purposes including enhancing user experience, optimizing our services, and transferring your data outside of your jurisdiction. You may withdraw your consent at any time by deleting your account. If you want to learn more about data privacy and cookies on our website, please read the
          {' '}
          <a href="https://www.fitch.group/policies" target="_blank" rel="noopener noreferrer" style={linkStyle}>Privacy Policy</a>
          {'.'}
        </FGTypography>
        <br></br>
        <div style={{ display: 'flex', flexDirection: 'column', margin: auto, maxWidth: '570px' }}>
          <div style={{ display: 'flex', alignItems: 'center', paddingTop: '10px', paddingBottom: '10px' }}>
            <FGCheckbox
              id="terms-of-use"
              onChange={handeTermsOfUseChange}
            />
            <TermsOfUse />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', paddingTop: '10px', paddingBottom: '10px'}}> 
            <FGCheckbox
              id="events-policy"
              onChange={handleEventsPolicyChange}
            />
            <EventsPolicy />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', paddingTop: '10px', paddingBottom: '30px' }}>
            <FGCheckbox
              id="cookie-policy"
              onChange={handleCookiePolicyChange}
            />
            <CookiePolicy />
          </div>
        </div>
        <div style={{ margin: auto, maxWidth: '370px', paddingBottom: '32px' }}>
          <FGButton id="submitBtn"
            fullWidth
            size="l"
            disabled={!isTermsOfUse || !isEventsPolicy || !isCookiePolicy}
            onClick={handleClick}
          >
            Create Account
          </FGButton>
        </div>
      </HeaderFooter>
    </>
  )
}